<template>
    <div class="box-add-image">
        <label for="uploadScreens">
        <img alt="picture" :src="formModel && formModel.avatar ? (formModel.avatar.includes('data:image') ? formModel.avatar : uploadUrl + formModel.avatar) : avatar" class="img-lg avatar rounded-circle border" /> 
        </label>
        <input
        class="d-none"
        ref="uploadScreens"
        type="file"
        id="uploadScreens"
        accept="image/*"
        @change="uploadScreen">
    </div>
      
</template>
<script>
import { mapGetters } from 'vuex';
import {STORE_KEY} from '../_store/constants';
import CropImage from './CropImage';
import { getAuth } from '@/utils/jwt';
import { APP_CONFIG } from '@/utils/constants';

export default {
    name: "ImageComp",
    components: {
      CropImage
    },

  data () {
    return {
      uploadUrl: APP_CONFIG.uploadUrl,
      avatar: require('@/assets/images/user-avatar.png')
    }
  },
  computed:{
    ...mapGetters({
      formModel: STORE_KEY + '/userProfileEdit'
    })
  },
  methods: {
    uploadScreen (e) {
      let file = e.target.files[0]

      const data = URL.createObjectURL(file)
      this.$modal.show(CropImage,
        {
          imageUrl: data
        },
        {
          width: 400,
          height: 560
        },
        {
          'get-data': this.getData
        }
      )
      this.$refs.uploadScreens.value = null
    },
    getData (data) {
      this.avatar = data;
      this.$emit('get-avatar', data)
    },
    
    hasImage (image) {
      return image
    }
  }
}
</script>

<style type="text/scss">
  .img-logo {
    width: 150px;
  }

</style>